import qs from 'qs';

import fetch from '@giro/shared-utils/fetch.util';

type FiltersType = {
  dateStart: string;
  dateEnd: string;
  type: 'crea' | 'ec';
};

export default async function getApiSettingsService() {
  const url = 'settings';

  return fetch(url, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
